import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const AddIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <circle cx="12" cy="12" r="10" fill={getColor(secondaryColor)} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.05001C6.50474 2.05001 2.04998 6.50477 2.04998 12C2.04998 17.4952 6.50474 21.95 12 21.95C17.4952 21.95 21.95 17.4952 21.95 12C21.95 6.50477 17.4952 2.05001 12 2.05001ZM0.349976 12C0.349976 5.56589 5.56586 0.350006 12 0.350006C18.4341 0.350006 23.65 5.56589 23.65 12C23.65 18.4341 18.4341 23.65 12 23.65C5.56586 23.65 0.349976 18.4341 0.349976 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.85 6.34979V17.6498H11.15V6.34979H12.85Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.34998 11.1496H17.65V12.8496H6.34998V11.1496Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default AddIconFilled;
